import { render } from "./footer-contact-home.vue?vue&type=template&id=6671b556"
import script from "./footer-contact-home.vue?vue&type=script&lang=js"
export * from "./footer-contact-home.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__